import React from 'react';
import { t } from 'i18next';
import { useNav } from '../../Context/Navigation';

export const Footer = ({ containerClasses }) => {
  const { currentPage } = useNav();

  return (
    <footer className={`absolute bottom-0 flex w-full ${containerClasses}`}>
      <div className="inline-flex flex-1 items-center justify-between p-6 md:mx-auto lg:px-8">
        <div className="flex gap-x-6 md:order-1">
          <span className="footer-text">{`© ${new Date().getFullYear()} Pure Desire Ministries`}</span>
        </div>
        {currentPage !== t('Library') && (
          <div className="flex md:order-2">
            <span className="footer-text">Version {process.env.REACT_APP_PD_VERSION}</span>
          </div>
        )}
      </div>
    </footer>
  );
};
